import moment from 'moment-timezone';
import TextStrings from './textStrings';
import Formats from './Formats';
import LocalStorage from '../utils/LocalStorageService';
import NumberFormatter from '../utils/NumberFormatter';

const init = () => {
  moment.updateLocale('en', {
    week: {
      dow: 1,
    },
    weekdays: Formats.weekdays.en,
  });
  moment.updateLocale('de', {
    weekdays: Formats.weekdays.de,
  });
  moment.updateLocale('nl', {
    weekdays: Formats.weekdays.nl,
  });
  moment.updateLocale('fr', {
    weekdays: Formats.weekdays.fr,
  });

  const storedLanguage = LocalStorage.getSelectedLanguage();

  if (storedLanguage && storedLanguage !== 'undefined') {
    const shortCode = storedLanguage.split('-')[0];
    moment.locale(shortCode);
    TextStrings.setLanguage(storedLanguage);
    NumberFormatter.setLocale(storedLanguage);
    return storedLanguage;
  } else {
    LocalStorage.storeLanguage('nl-NL');
    moment.locale('nl');
    TextStrings.setLanguage('nl-NL');
    NumberFormatter.setLocale('nl-NL');
    return 'nl-NL';
  }
};

export default { init };
